// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empty-root {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  padding: 36px 20px;
}

.empty-image {
  object-fit: cover;
}
.empty-text-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.empty-state-butns {
  display: flex;
  gap: 12px;
}

.settingBtn .MuiButtonBase-root.MuiButton-root {
  height: 40px !important;
  margin-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/reusableComponents/ConfigEmptyState/emptyState.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB","sourcesContent":[".empty-root {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  padding: 36px 20px;\n}\n\n.empty-image {\n  object-fit: cover;\n}\n.empty-text-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n}\n\n.empty-state-butns {\n  display: flex;\n  gap: 12px;\n}\n\n.settingBtn .MuiButtonBase-root.MuiButton-root {\n  height: 40px !important;\n  margin-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
